export default [
  'de',
  'com',
  'net',
]
